<template>
	<div class="main-store">
		<navigations :path="path"></navigations>

		<img class="store-img" src="../assets/back-2.png" alt="">

		<div class="container-store">

			<div class="store-hint">
				商家入驻
			</div>

			<div class="store-line"></div>

			<div class="store-image">
				<img class="store-image-title" src="../assets/store-add.png" alt="">
			</div>

			<div class="store-line store-line-phone"></div>

			<div class="store-text-box">
				<img class="store-text-img" src="../assets/store-text-1.png" alt="">
			</div>

			<div class="store-text-box store-text-box-phone">
				<img class="store-text-img" src="../assets/store-text-phone-1.png" alt="">
			</div>

			<div class="store-line"></div>

			<div class="store-line store-line-phone"></div>

			<div class="store-center">
				<img class="store-map" src="../assets/store-text-2.png" alt="">
			</div>

			<div class="store-center store-center-phone">
				<img class="store-map" src="../assets/store-text-phone-2.png" alt="">
			</div>

			<div class="store-line"></div>
			
			<div class="store-line store-line-phone"></div>

			<div class="store-hint">
				入驻案例
			</div>

			<div class="store-hint-2">
				天府火锅入驻案例
			</div>

			<div class="store-hint-3">
				在业务经理协助下,1个月内售出1850单
			</div>

			<div class="store-center">
				<img class="store-map" src="../assets/store-3.png" alt="">
			</div>
			
			<div class="store-center store-center-phone">
				<img class="store-map" src="../assets/store-phone-3.png" alt="">
			</div>

			<div class="store-line"></div>
			
			<div class="store-line store-line-phone"></div>
			
			<div class="store-hint store-hint-phone">
				TA的经营秘诀，你也可以
			</div>
			
			<div class="store-center store-center-phone">
				<img class="store-map" src="../assets/store-phone-4.png" alt="">
			</div>
			
			<div class="store-line store-line-phone"></div>
			
			<div class="store-hint">
				开店要求
			</div>

			<div class="store-content">
				<span class="store-content-title">
					实体门店
				</span>
				<span class="store-content-text">
					入驻时购圈需有线下实体店铺，若无实体门店无法通过审核
				</span>
			</div>

			<div class="store-content">
				<span class="store-content-title">
					经营资质
				</span>
				<span class="store-content-text">
					需提供符合国家法律规定的经营者身份、行政许可等信息，包括但不限于营业执照、各类许可证;
				</span>
				<span class="store-content-text">
					堵截虚假资质，违者无法合作 查看开店材料清单
				</span>
			</div>

			<div class="store-content">
				<span class="store-content-title">
					品类范围
				</span>
				<span class="store-content-text">
					时购圈平台支持众多商家入驻：包含并不限于，各色美食餐饮、KTV、酒吧 、桌游、密室逃脱、各类体育引动经营项目等等
				</span>
			</div>
			<div class="store-line store-line-phone"></div>
			
			<div class="store-content">
				<span class="store-content-title-1">
					入驻流程
				</span>
				<img class="store-content-img" src="../assets/store-4.png" alt="">
				<img class="store-content-img-phone" src="../assets/store-phone-5.png" alt="">
			</div>
			
			<div class="store-line store-line-phone"></div>

			<div class="store-line"></div>

			<div class="store-hint-2">
				入驻申请
			</div>

			<div class="store-form">
				<el-input class="store-form-input" v-model="name" placeholder="申请人姓名"></el-input>
				<el-input class="store-form-input" v-model="store" placeholder="申请店铺名称"></el-input>
				<el-input class="store-form-input" v-model="phone" placeholder="申请人联系方式"></el-input>
				<el-input class="store-form-input" v-model="remark" placeholder="备注信息"></el-input>
				<el-button class="store-form-primary" type="primary" :disabled="disabled"
					@click="onSubmit">提交申请</el-button>
			</div>

			<div class="store-line"></div>
			
			<div class="store-line store-line-phone"></div>
			
			<div class="store-center">
				<img class="store-service" src="../assets/serivce.png" alt="">
			</div>
			
			<div class="store-center store-center-phone">
				<img class="store-service" src="../assets/serivce.png" alt="">
			</div>

		</div>
		<tabbar></tabbar>
	</div>

</template>

<script>
	export default {
		name: 'store',
		props: {
			msg: String
		},
		data() {
			return {
				path: '/store',
				name: '',
				store: '',
				phone: '',
				remark: '',
				flag: true,
				disabled: false
			}
		},
		methods: {
			onSubmit() {
				if (this.name == null || this.name == '') {
					alert("申请人姓名不能为空")
					return
				}
				if (this.store == null || this.store == '') {
					alert("申请店铺名称不能为空")
					return
				}
				if (this.phone == null || this.phone == '') {
					alert("申请人联系方式不能为空")
					return
				}
				let THIS = this;
				if (this.flag) {
					this.flag = false;
					this.disabled = true;
					setTimeout(function() {
						THIS.flag = true;
						THIS.disabled = false;
					}, 3000)
					this.setApply();
				}
			},
			setApply() {
				let params = {
					linkman: this.name,
					store: this.store,
					phone: this.phone,
					remark: this.remark
				}
				let url = 'https://client.10jq.co/buyer/player/merchant/addStoreApply/' + this.name + '/' + this.store +
					'/' + this.phone + '/' + this.remark
				this.$http.post(url, params).then(res => {
					if (res.body.success) {
						alert("已提交申请")
						location.reload();
					} else {
						alert("申请失败，请稍后再试")
					}
				}, error => {
					alert("申请失败，请稍后再试")
				})
			}
		}
	}
</script>

<style>
	html,
	body {
		width: 100%;
		height: 100%;
		margin: 0;
		overflow: auto;
	}

	.main-store {
		width: 100%;
		height: 100%;
		padding-top: 100px;
		box-sizing: border-box;
	}

	.container-store {
		width: 100%;
		min-height: 100%;
		padding: 5% 15% 0 15%;
		box-sizing: border-box;
	}

	.store-center {
		width: 100%;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: flex-start;
		justify-content: center;
		align-items: flex-start;
		min-height: 100px;
	}

	.store-line {
		width: 100%;
		height: 1px;
		background-color: rgba(0, 0, 0, 0.5);
		margin-top: 100px;
		margin-bottom: 100px;
	}

	.store-map {
		width: 100%;
	}

	.store-hint {
		width: 100%;
		font-weight: 900;
		letter-spacing: 5px;
		font-size: 48px;
		color: #383838;
	}

	.store-img {
		width: 100%;
	}

	.store-text {
		width: 100%;
		margin-top: 100px;
		margin-bottom: 100px;
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;
	}

	.store-text span {
		letter-spacing: 2px;
		color: #808080;
		font-size: 16px;
		line-height: 30px;
	}

	.store-image {
		width: 100%;
		height: 100px;
		box-sizing: border-box;
	}

	.store-image-title {
		width: 30%;
	}

	.store-text-box {
		width: 100%;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: flex-start;
		justify-content: flex-start;
		align-items: flex-start;
		min-height: 100px;
	}

	.store-text-img {
		width: 88%;
	}

	.store-hint-2 {
		width: 100%;
		font-weight: 900;
		letter-spacing: 5px;
		font-size: 30px;
		margin-top: 30px;
		color: #383838;
	}

	.store-hint-3 {
		width: 100%;
		font-weight: 900;
		font-size: 16px;
		color: #808080;
		margin-top: 15px;
		margin-bottom: 50px;
	}

	.store-content {
		width: 100%;
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;
		margin-top: 50px;
	}

	.store-content-title {
		width: 70%;
		height: 50px;
		border-bottom: 1px solid #EBEBEB;
		font-size: 30px;
		color: #383838;
	}

	.store-content-text {
		font-size: 16px;
		color: #808080;
		margin-top: 15px;
	}

	.store-content-title-1 {
		width: 70%;
		height: 50px;
		font-size: 30px;
		color: #383838;
	}

	.store-content-img {
		width: 70%;
		margin-top: 30px;
	}

	.store-form {
		width: 100%;
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;
	}

	.store-form-input {
		margin-top: 15px;
		width: 30%;
	}

	.store-form-primary {
		margin-top: 15px;
		background-color: #00BAAD;
		border: 0;
		border-radius: 10px;
		letter-spacing: 3px;
		width: 200px;
		margin-top: 50px;
		font-size: 24px;
	}

	.store-service {
		width: 50%;
		margin-bottom: 100px;
	}

	.store-line-phone {
		display: none;
	}

	.store-text-box-phone {
		display: none;
	}

	.store-center-phone {
		display: none;
	}
	
	.store-hint-phone{
		display: none;
	}
	
	.store-content-img-phone{
		display: none;
	}

	@media screen and (max-width: 768px) {
		.store-content-img{
			display: none;
		}
		
		.store-line {
			display: none;
		}

		.store-center {
			display: none;
		}

		.store-text-box {
			display: none;
		}

		.store-hint {
			font-size: 24px;

		}

		.main-store {
			padding-top: 70px;
		}

		.container-store {
			padding: 15% 5% 0 5%;
		}

		.store-line {
			margin-top: 30px;
			margin-bottom: 30px;
		}

		.store-image {
			width: 100%;
			height: 50px;
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			align-items: center;
			justify-content: center;
		}

		.store-image-title {
			width: 60%;
		}

		.store-form-input {
			width: 90%;
		}

		.store-service {
			margin-bottom: 0px;
			width: 100%;
		}

		.store-line-phone {
			display: block;
		}

		.store-text-box-phone {
			display: inline;
			width: 100%;
		}

		.store-text-img {
			width: 100%;
		}

		.store-center-phone {
			display: flex;
			width: 100%;
			height: auto;
			flex-direction: column;
			flex-wrap: nowrap;
			align-content: center;
			justify-content: center;
			align-items: center;
			margin-top: 50px;
		}
		
		.store-hint-2{
			font-size: 18px;
		}
		
		.store-hint-3{
			font-size: 12px;
		}
		
		.store-hint-phone{
			display: inline;
			font-size: 20px;
		}
		
		.store-content-title{
			font-size: 18px;
			border-bottom: 0;
			height: 30px;
		}
		
		.store-content-text{
			font-size: 12px;
		}
		
		.store-content-img-phone{
			width: 100%;
			margin-top: 30px;
			display: block;
		}
		
		.el-input__inner{
			background-color: #F7F7F7;
			color: #A6A6A6;
			border: 0;
		}
		
		.store-form-primary{
			width: 100px;
			font-size: 12px;
		}
	}
</style>